module.exports = __webpack_public_path__ + "img/curvainferior.2d30905b.svg";